/**
 * @file formUserInputFields
 * 個人情報入力画面 項目名
 */

import * as FormUserInputOptionConstants from '@/js/util/member/formUserInputOptionConstants'
import moment from 'moment'

// interface required: Boolean
// interface isShow: Boolean

/**
 * 未成年かどうかをチェック
 * 生年月日入力のルール確認
 * https://actbeinc.backlog.com/view/TC_WEB_SYS-17
 * @param {*} _birthday 生年月日
 */
export const isMinors = (_birthday) => {
  // TODO 引数から年・月・日にちにバラす
  // 一旦YYYY-MM-DD で取得する想定にする
  const y = _birthday.split('-')[0]
  const m = _birthday.split('-')[1]
  const d = _birthday.split('-')[2]
  const birthday = moment()
    .year(y)
    .month(m - 1)
    .date(d)
  return moment().diff(birthday, 'years') < 20
}

/**
 * 個人情報入力画面の情報
 * 申込み時のステータス「change」は信販申込のみ
 * @param {string} category 申込種別 (credit or installment)
 * @param {object} formState
 * @param {string} registration 申込み時のステータス (new, add, change)
 */
export const FormUserInputFields = (category, formState, registration) => {
  return {
    // 申込日
    applicationDate: {
      key: 'application_date',
      name: '申込日',
      required: true,
      isShow: true,
      // era: {
      //     key: 'application_date_era',
      //     name: '元号'
      // },
      year: {
        key: 'application_date_year',
        name: '年'
      },
      month: {
        key: 'application_date_month',
        name: '月'
      },
      day: {
        key: 'application_date_day',
        name: '日'
      }
    },
    // 取引を行う目的
    purposeOfTransaction: {
      key: 'purpose_of_transaction',
      name: '取引を行う目的',
      choices: FormUserInputOptionConstants.PurposeOfTransaction,
      required: category === 'credit' && registration === 'new',
      isShow: category === 'credit' && registration === 'new'
    },
    // 取引を行う目的その他
    purposeOfTransactionOtherName: {
      key: 'purpose_of_transaction_other_name',
      name: '取引を行う目的（その他）',
      isShow: true,
      required: formState.purpose_of_transaction === 'その他'
    },
    // 外国政府等重要な公的地位にある方等とのお取引に該当する
    isForeignGovernment: {
      key: 'is_foreign_government',
      name: '外国政府等重要な公的地位にある方等とのお取引に該当する',
      choices: FormUserInputOptionConstants.IsForeignGovernment,
      required: category === 'credit' && registration === 'new',
      isShow: category === 'credit' && registration === 'new'
    },
    // 外国政府等重要な公的地位にある方等とのお取引に該当する (国、職名)
    foreignGovernmentCompany: {
      key: 'foreign_government_company',
      name: '国、職名',
      isShow: true,
      required: formState.isForeignGovernment === 'はい',
      placeholder: '国名・職名'
    },
    // 氏名 漢字
    name: {
      isShow: true,
      required: true,
      name: '氏名 漢字',
      surname: {
        key: 'surname',
        name: '姓',
        required: true
      },
      firstName: {
        key: 'first_name',
        name: '名',
        required: true
      }
    },
    // 氏名 フリガナ
    nameKana: {
      isShow: true,
      required: true,
      name: '氏名 フリガナ',
      surname: {
        key: 'surname_kana',
        name: 'セイ',
        required: true
      },
      firstName: {
        key: 'first_name_kana',
        name: 'メイ',
        required: true
      }
    },
    // 旧姓 漢字
    oldSurname: {
      key: 'old_surname',
      isShow: category === 'credit',
      required: false,
      name: '旧姓 漢字',
    },
    // 旧姓 カナ
    oldSurnameKana: {
      key: 'old_surname_kana',
      isShow: category === 'credit',
      required: false,
      name: '旧姓 カナ',
    },
    // 性別
    sexType: {
      key: 'sex_type',
      name: '性別',
      choices: FormUserInputOptionConstants.SexType,
      required: true,
      isShow: true
    },
    // 生年月日
    birthday: {
      key: 'birthday',
      name: '生年月日',
      required: true,
      isShow: true
    },
    // 郵便番号
    postNumber: {
      key: 'post_number',
      name: '〒',
      required: true,
      isShow: true
    },
    // 住所
    address: {
      name: '住所',
      required: true,
      isShow: true,
      address1: {
        key: 'street_address1',
        name: '',
        required: true,
        placeholder: '都道府県市区町・番地'
      },
      address2: {
        key: 'street_address2',
        name: '',
        required: false,
        placeholder: '建物名・部屋番号'
      }
    },
    // 住所カナ
    addressKana: {
      name: '住所カナ',
      required: false,
      isShow: true,
      key: 'street_address_kana',
      placeholder: 'カタカナで県市町まで入力してください'
    },
    // 自宅TEL
    tel: {
      key: 'tel',
      name: '自宅TEL',
      required: false,
      isShow: true
    },
    // 携帯TEL
    mobile: {
      key: 'mobile',
      name: '携帯TEL',
      required: true,
      isShow: true
    },
    // ご家族
    // family: {
    //     name: 'ご家族',
    //     isShow: true,
    //     required: true,
    //     hasSpouse: {
    //         key: 'has_spouse',
    //         name: '配偶者',
    //         choices: FormUserInputOptionConstants.HasSpouse,
    //         required: true
    //     },
    //     parentLiving: {
    //         key: 'parent_living',
    //         name: '親同居',
    //         choices: FormUserInputOptionConstants.ParentLiving,
    //         required: true
    //     },
    //     childStatus: {
    //         key: 'child_status',
    //         name: '子供',
    //         choices: FormUserInputOptionConstants.ChildStatus,
    //         required: true
    //     },
    //     childNumber: {
    //         key: 'child_number',
    //         name: '子供人数',
    //         required: formState.child_status === '有'
    //     },
    //     othersStatus: {
    //         key: 'others_status',
    //         name: 'その他',
    //         choices: FormUserInputOptionConstants.OthersStatus,
    //         required: true
    //     },
    //     othersNumber: {
    //         key: 'others_number',
    //         name: 'その他人数',
    //         required: formState.others_status === '有'
    //     },
    // },
    // ご家族について
    familyAbout: {
      key: 'family_about',
      name: 'ご家族について',
      isShow: !(category === 'credit' && registration === 'add'), // [追加]クレジット申込は非表示
      required: !(category === 'credit' && registration === 'add'), // [追加]クレジット申込はnullable
      choices: FormUserInputOptionConstants.FamilyAbout
    },
    // ご家族についての同居人数
    familyAboutNumber: {
      key: 'family_about_number',
      name: '同居人数',
      isShow: !(category === 'credit' && registration === 'add'), // [追加]クレジット申込は非表示
      required: !(category === 'credit' && registration === 'add') // [追加]クレジット申込はnullable
    },
    // 生計同一人数
    familyStructure: {
      key: 'family_structure',
      name: '生計同一人数',
      required: (category === 'credit' || category === 'installment') && registration === 'new',
      isShow: (category === 'credit' || category === 'installment') && registration === 'new',
      choices: FormUserInputOptionConstants.FamilyStructure
    },
    // ご住居(住居形態)
    residenceClassification: {
      key: 'residence_classification',
      name: 'ご住居',
      choices: FormUserInputOptionConstants.ResidenceClassification,
      required: !(category === 'credit' && registration === 'add'), // [追加]クレジット申込は非表示,
      isShow: !(category === 'credit' && registration === 'add') // [追加]クレジット申込はnullable
    },
    // 居住年数
    residencePeriod: {
      name: '居住年数',
      required: !(category === 'credit' && registration === 'add'), // [追加]クレジット申込は非表示,
      isShow: !(category === 'credit' && registration === 'add'), // [追加]クレジット申込はnullable
      year: {
        key: 'residence_period_year',
        choices: FormUserInputOptionConstants.ResidencePeriodYears
      }
    },
    // ローン・家賃の支払い
    loanRent: {
      key: 'loan_rent',
      name: 'ローン・家賃の支払い',
      choices: FormUserInputOptionConstants.LoanRent,
      required: category === 'credit' && registration === 'new',
      isShow: category === 'credit' && registration === 'new'
    },
    // お申込者と世帯主の関係
    householderRelationOptions: {
      name: 'お申込者と世帯主の関係',
      required: (category === 'credit' || category === 'installment') && registration === 'new',
      isShow: (category === 'credit' || category === 'installment') && registration === 'new',
      householderRelation: {
        key: 'householder_relation',
        name: '',
        choices: FormUserInputOptionConstants.HouseholderRelation,
        required: category === 'credit' || category === 'installment'
      }
    },
    // 世帯主の税込年収
    householderIncome: {
      key: 'householder_income',
      name: '世帯主の税込年収',
      required:
        (category === 'credit' && registration === 'new' && formState.householder_relation === '配偶者') ||
        (category === 'credit' && registration === 'new' && formState.occupation === '専業主婦'),
      isShow: category === 'credit' && registration === 'new'
    },
    // 世帯主の所得種類
    householderIncomeType: {
      key: 'householder_income_type',
      name: '世帯主の所得種類',
      required:
        (category === 'credit' && registration === 'new' && formState.householder_relation === '配偶者') ||
        (category === 'credit' && registration === 'new' && formState.occupation === '専業主婦'),
      isShow: category === 'credit' && registration === 'new',
      choices: FormUserInputOptionConstants.HouseholderIncomeType
    },
    householderIncomeTypeOtherName: {
      key: 'householder_income_type_other_name',
      name: '世帯主の所得種類その他',
      required: formState.householder_income_type === 'その他',
      isShow: category === 'credit' && registration === 'new'
    },
    // 世帯主のクレジット月間支払額
    householderMonthlyCreditPayments: {
      key: 'householder_monthly_credit_payments',
      name: '世帯主のクレジット月間支払額',
      required:
        (category === 'credit' && formState.householder_relation === '配偶者') ||
        (category === 'credit' && formState.occupation === '専業主婦'),
      isShow: category === 'credit' && registration === 'new'
    },
    // 実家住所
    parentHouseOptions: {
      name: '実家住所・TEL',
      required: false,
      isShow: true,   // 新規申込時の実家情報を入力必須化する際に、"[追加]クレジット申込は非表示"の制御を無くした
      parentsPost: {
        key: 'parents_post',
        name: '〒',
        required: (category === 'credit' || category === 'installment') && registration === 'new'
      },
      parentsAddress: {
        name: '住所',
        required: (category === 'credit' || category === 'installment') && registration === 'new',
        address: {
          key: 'parents_address',
          required: false,
          placeholder: '県市町・番地・マンション名・号室まで入力してください'
        }
      },
      phone: {
        required: (category === 'credit' || category === 'installment') && registration === 'new',
        phone1: {
          key: 'parents_phone1'
        },
        phone2: {
          key: 'parents_phone2'
        },
        phone3: {
          key: 'parents_phone3'
        },
        mobilePhone1: {
          key: 'parents_mobile_phone1'
        },
        mobilePhone2: {
          key: 'parents_mobile_phone2'
        },
        mobilePhone3: {
          key: 'parents_mobile_phone3'
        },
        // 実家携帯電話の続柄
        relationShip: {
          key: 'parents_phone_relationship',
          name: '実家携帯電話の続柄',
          choices: FormUserInputOptionConstants.ParentsPhoneRelationship,
          // required: category === 'credit'
        },
        // 実家携帯電話の続柄その他
        relationShipOtherName: {
          key: 'parents_phone_relationship_other_name',
          name: '実家携帯電話の続柄（その他）',
          required: formState.parents_phone_relationship === 'その他'
        },
      }
    },
    // お勤め先・学校について
    occupation: {
      key: 'occupation',
      name: '職業',
      choices: FormUserInputOptionConstants.Occupation[category],
      required: true,
      isShow: true
    },
    // お勤め先・学校についてその他
    occupationOtherName: {
      key: 'occupation_other_name',
      name: '',
      required: formState.occupation === 'その他'
    },
    // 就業形態
    // employmentStatus: {
    //     key: 'employment_status',
    //     name: '就業形態',
    //     choices: FormUserInputOptionConstants.EmploymentStatus[category],
    //     required: (category === 'installment' && formState.occupation !== '専業主婦' && formState.occupation !== '無職') || (category === 'credit' && formState.occupation === '有職者'),
    //     isShow: (category === 'installment' && formState.occupation !== '専業主婦' && formState.occupation !== '無職') || (category === 'credit' && formState.occupation === '有職者')
    // },
    // アルバイトをされていない方向けのチェック
    studentUnemployedFlg: {
      key: 'student_unemployed_flg',
      name: '',
      isShow:
        category === 'installment' && (formState.occupation === '学生（アルバイト）' || formState.occupation === '学生')
    },
    // 就業形態その他
    employmentStatusOtherName: {
      key: 'employment_status_other_name',
      name: '',
      required: formState.employment_status === 'その他'
    },
    // 卒業予定
    expectedGraduation: {
      name: '卒業予定',
      required: category === 'credit' && registration === 'new' && formState.occupation === '学生（アルバイト）' || formState.occupation === '学生',
      isShow: category === 'credit' && formState.occupation === '学生（アルバイト）' || formState.occupation === '学生',
      year: {
        key: 'graduate_year'
      },
      month: {
        key: 'graduate_month'
      }
    },
    // お勤め先
    companyName: {
      key: 'company_name',
      name: 'お勤め先',
      required:
        (category === 'credit' && formState.occupation !== '専業主婦') ||
        (category === 'installment' &&
          (formState.occupation !== '専業主婦' &&
          formState.occupation !== '無職' &&
          formState.occupation !== '学生（アルバイト）') || 
          (formState.occupation === '学生（アルバイト）' && !formState.student_unemployed_flg)),
      isShow:
        (category === 'credit' && formState.occupation !== '専業主婦') ||
        (category === 'installment' &&
          (formState.occupation !== '専業主婦' &&
          formState.occupation !== '無職' &&
          formState.occupation !== '学生（アルバイト）') || 
          (formState.occupation === '学生（アルバイト）' && !formState.student_unemployed_flg)),
    },
    // お勤め先 フリガナ
    companyNameKana: {
      key: 'company_name_kana',
      name: 'お勤め先 フリガナ',
      required:
        (category === 'credit' && formState.occupation !== '専業主婦') ||
        (category === 'installment' &&
          (formState.occupation !== '専業主婦' &&
          formState.occupation !== '無職' &&
          formState.occupation !== '学生（アルバイト）') || 
          (formState.occupation === '学生（アルバイト）' && !formState.student_unemployed_flg)),
      isShow:
        (category === 'credit' && formState.occupation !== '専業主婦') ||
        (category === 'installment' &&
          (formState.occupation !== '専業主婦' &&
          formState.occupation !== '無職' &&
          formState.occupation !== '学生（アルバイト）') || 
          (formState.occupation === '学生（アルバイト）' && !formState.student_unemployed_flg)),
    },
    // お勤め先 郵便番号
    companyPost: {
      key: 'company_post',
      name: 'お勤め先 〒',
      required: category === 'credit' && registration === 'new' && formState.occupation !== '専業主婦',
      isShow:
        (category === 'credit' && formState.occupation !== '専業主婦') ||
        (category === 'installment' &&
          (formState.occupation !== '専業主婦' &&
          formState.occupation !== '無職' &&
          formState.occupation !== '学生（アルバイト）') || 
          (formState.occupation === '学生（アルバイト）' && !formState.student_unemployed_flg)),
    },
    // お勤め先 住所
    companyAddress: {
      name: 'お勤め先住所',
      required: category === 'credit' && registration === 'new' && formState.occupation !== '専業主婦',
      isShow:
        (category === 'credit' && formState.occupation !== '専業主婦') ||
        (category === 'installment' &&
          (formState.occupation !== '専業主婦' &&
          formState.occupation !== '無職' &&
          formState.occupation !== '学生（アルバイト）') || 
          (formState.occupation === '学生（アルバイト）' && !formState.student_unemployed_flg)),
      address: {
        key: 'company_address',
        placeholder: '県市町・番地・マンション名・号室まで入力してください'
      }
    },
    // お勤め先TEL
    companyPhone: {
      name: 'お勤め先TEL',
      required:
        (category === 'credit' && formState.occupation !== '専業主婦') ||
        (category === 'installment' &&
          (formState.occupation !== '専業主婦' &&
          formState.occupation !== '無職' &&
          formState.occupation !== '学生（アルバイト）') || 
          (formState.occupation === '学生（アルバイト）' && !formState.student_unemployed_flg)),
      isShow:
        (category === 'credit' && formState.occupation !== '専業主婦') ||
        (category === 'installment' &&
          (formState.occupation !== '専業主婦' &&
          formState.occupation !== '無職' &&
          formState.occupation !== '学生（アルバイト）') || 
          (formState.occupation === '学生（アルバイト）' && !formState.student_unemployed_flg)),
      phone1: {
        key: 'company_phone1'
      },
      phon2: {
        key: 'company_phone2'
      },
      phone3: {
        key: 'company_phone3'
      }
    },
    // 仕事内容
    companyJobDescription: {
      key: 'company_job_description',
      name: '仕事内容',
      choices: FormUserInputOptionConstants.CompanyJobDescription[category],
      required:
        (category === 'credit' && registration === 'new' && formState.occupation !== '専業主婦') ||
        (category === 'installment' &&
          (formState.occupation !== '専業主婦' &&
          formState.occupation !== '無職' &&
          formState.occupation !== '学生（アルバイト）') || 
          (formState.occupation === '学生（アルバイト）' && !formState.student_unemployed_flg)),
      isShow:
        (category === 'credit' && formState.occupation !== '専業主婦') ||
        (category === 'installment' &&
          (formState.occupation !== '専業主婦' &&
          formState.occupation !== '無職' &&
          formState.occupation !== '学生（アルバイト）') || 
          (formState.occupation === '学生（アルバイト）' && !formState.student_unemployed_flg)),
    },
    // 仕事内容その他
    companyJobDescriptionOtherName: {
      key: 'company_job_description_other_name',
      name: '仕事内容その他',
      required: formState.company_job_description === 'その他'
    },
    // 所属部課
    jobDepartment: {
      key: 'job_department',
      name: '所属部課',
      required: false, // 任意
      isShow:
        (category === 'credit' && formState.occupation !== '専業主婦') ||
        (category === 'installment' &&
          (formState.occupation !== '専業主婦' &&
          formState.occupation !== '無職' &&
          formState.occupation !== '学生（アルバイト）') || 
          (formState.occupation === '学生（アルバイト）' && !formState.student_unemployed_flg)),
    },
    // 出向派遣元
    dispatchedAgent: {
      key: 'dispatched_agent',
      name: '出向派遣元',
      required: false, // 任意
      isShow:
        (category === 'credit' && formState.occupation !== '専業主婦') ||
        (category === 'installment' &&
          (formState.occupation !== '専業主婦' &&
          formState.occupation !== '無職' &&
          formState.occupation !== '学生（アルバイト）') || 
          (formState.occupation === '学生（アルバイト）' && !formState.student_unemployed_flg)),
    },
    // 入社年月
    joinDate: {
      name: '入社年月',
      required: category === 'credit' && registration === 'new' && formState.occupation !== '専業主婦', // 任意と必須
      isShow:
        (category === 'credit' && formState.occupation !== '専業主婦') ||
        (category === 'installment' &&
          (formState.occupation !== '専業主婦' &&
          formState.occupation !== '無職' &&
          formState.occupation !== '学生（アルバイト）') || 
          (formState.occupation === '学生（アルバイト）' && !formState.student_unemployed_flg)),
      year: {
        key: 'join_year'
      },
      month: {
        key: 'join_month'
      }
    },
    // 給料日
    payday: {
      name: '給料日',
      key: 'payday',
      required: category === 'credit' && registration === 'new' && formState.occupation !== '専業主婦', // 任意と必須
      isShow:
        (category === 'credit' && formState.occupation !== '専業主婦') ||
        (category === 'installment' &&
          (formState.occupation !== '専業主婦' &&
          formState.occupation !== '無職' &&
          formState.occupation !== '学生（アルバイト）') || 
          (formState.occupation === '学生（アルバイト）' && !formState.student_unemployed_flg)),
    },
    // 税込年収
    companyIncome: {
      key: 'company_income',
      name: '税込年収',
      required:
        (category === 'credit' && registration === 'new' && formState.occupation !== '専業主婦') ||
        (category === 'installment' &&
          (formState.occupation !== '専業主婦' &&
          formState.occupation !== '無職' &&
          formState.occupation !== '学生（アルバイト）') || 
          (formState.occupation === '学生（アルバイト）' && !formState.student_unemployed_flg)),
      isShow:
        (category === 'credit' && formState.occupation !== '専業主婦') ||
        (category === 'installment' &&
          (formState.occupation !== '専業主婦' &&
          formState.occupation !== '無職' &&
          formState.occupation !== '学生（アルバイト）') || 
          (formState.occupation === '学生（アルバイト）' && !formState.student_unemployed_flg)),
    },
    // その他収入(年額)
    sidelineType: {
      key: 'sideline_type',
      name: 'その他収入(年額)',
      required: false, // 任意
      choices: FormUserInputOptionConstants.SidelineType,
      isShow:
        (category === 'credit' && formState.occupation !== '専業主婦') ||
        (category === 'installment' &&
          (formState.occupation !== '専業主婦' &&
          formState.occupation !== '無職' &&
          formState.occupation !== '学生（アルバイト）') || 
          (formState.occupation === '学生（アルバイト）' && !formState.student_unemployed_flg)),
    },
    // その他年収(その他テキスト)
    sidelineOtherName: {
      key: 'sideline_other_name',
      name: '',
      required: formState.sideline_type === 3
    },
    // その他年収 金額
    sidelineIncome: {
      key: 'sideline_income',
      name: '',
      required: false
    },
    // ご署名
    // signature: {
    //     key: 'signature',
    //     name: 'ご署名',
    //     required: true,
    //     isShow: true
    // },
    // お勤め先社員数
    comapnyEmployeesNumber: {
      key: 'comapny_employees_number',
      name: 'お勤め先社員数',
      required: false,
      isShow: false
    },
    // 預金額
    bankDeposit: {
      key: 'bank_deposit',
      name: '預金額',
      required: false,
      isShow: false
    },
    // 配偶者の年収
    spouseIncome: {
      key: 'spouse_income',
      name: '配偶者の年収',
      required: false,
      isShow: false
    },
    // 未成年の場合は保護者同意書(既婚者は不要)
    // parentalConsentForm: {
    //     key: 'parental_consent_form',
    //     name: '未成年の場合は保護者同意書【既婚者は不要】',
    //     required: category === 'credit' && (formState.has_spouse === '無' && isMinors(formState.birthday)), // category === 'credit' && 未成年且つ配偶者がいない場合
    //     isShow: category === 'credit'
    // }
    // 変更届フラグ
    isChangeCustomer: {
      key: 'is_change_customer',
      name: '変更届',
      required: registration === 'add',
      choices: FormUserInputOptionConstants.ChangeUserInfoFlags,
      isShow: registration === 'add'
    }
  }
}
